/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import * as React from 'react';
import { Button, Container } from 'reactstrap';

interface Props {
    isEnabled: boolean;
    isAvailable: boolean;
    onEnable: () => void;
    onDisable: () => void;
    onReload: () => void;
    onSchedule: () => void;
}

export const JobActions: React.FC<Props> = (props) => {
    return (
        <Container>
            {!props.isEnabled && props.isAvailable && (
                <Button className="m-2" color="success" onClick={props.onEnable} outline={false}>
                    Enable
                </Button>
            )}
            {props.isEnabled && props.isAvailable && (
                <Button className="m-2" color="warning" onClick={props.onDisable} outline={false}>
                    Disable
                </Button>
            )}
            {props.isAvailable && (
                <Button className="m-2" color="primary" onClick={props.onSchedule} outline={false}>
                    Schedule
                </Button>
            )}
            <Button className="m-2" color="secondary" onClick={props.onReload} outline={false}>
                Reload
            </Button>
        </Container>
    );
};
